import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './ModuloHome.css';
import { ModuloApi } from '../../api/ModuloApi';
import { UsuarioModuloApi } from '../../api/UsuarioModuloApi';
import { UserContext } from '../../App';
import { FaLock, FaCheckCircle, FaPlayCircle } from 'react-icons/fa';

const ModuloHome = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Contenidos');
  const [modulos, setModulos] = useState([]);
  const [moduleStatus, setModuleStatus] = useState([]);
  const [isRelationsChecked, setIsRelationsChecked] = useState(false);

  const user = useContext(UserContext);
  const moduloApi = new ModuloApi();
  const modulousuarioapi = new UsuarioModuloApi();

  const fetchModulos = async () => {
    try {
      const data = await moduloApi.getAllModulo();
      setModulos(data);
      checkRelations(data);
    } catch (error) {
      console.error('Error fetching modulos:', error);
    }
  };

  const checkRelations = async (modulos) => {
    if (!isRelationsChecked && modulos.length > 0) {
      let statusArray = modulos.map(() => ({ unlocked: false, relationExists: false }));
      let lastUnlockedIndex = -1;

      for (let i = 0; i < modulos.length; i++) {
        try {
          const response = await modulousuarioapi.checkUsuarioModuloExists(user.id, modulos[i].id);
          const exists = response.exists !== 0;
          if (i === 0) {
            statusArray[i] = { unlocked: true, relationExists: exists };
            if (exists) lastUnlockedIndex = i;
          } else if (lastUnlockedIndex !== -1 && statusArray[lastUnlockedIndex].relationExists === true && !exists) {
            statusArray[i] = { unlocked: true, relationExists: exists };
            lastUnlockedIndex = i;
          } else {
            statusArray[i] = { unlocked: false, relationExists: exists };
          }
          if (statusArray[i].relationExists) statusArray[i].unlocked = true;
        } catch (error) {
          console.error(`Error checking relation for module ${modulos[i].modulo_name}:`, error);
        }
      }
      setModuleStatus(statusArray);
      setIsRelationsChecked(true);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchModulos(); }, []);

  const completedCount = moduleStatus.filter(s => s?.relationExists).length;

  return (
    <div className="modulo-home-container">

      {/* Hero */}
      <div className="mh-hero">
        <div className="mh-hero-content">
          <div className="mh-badge">Formación en Ventas</div>
          <h1 className="mh-title">Closer Academy</h1>
          <p className="mh-subtitle">
            Domina las habilidades, técnicas y estrategias esenciales para triunfar
            en el mundo de las ventas. Aprende a tu ritmo y avanza módulo a módulo.
          </p>
          {modulos.length > 0 && (
            <div className="mh-progress-bar-wrap">
              <div className="mh-progress-info">
                <span>{completedCount} de {modulos.length} módulos completados</span>
                <span>{Math.round((completedCount / modulos.length) * 100)}%</span>
              </div>
              <div className="mh-progress-track">
                <div
                  className="mh-progress-fill"
                  style={{ width: `${(completedCount / modulos.length) * 100}%` }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div className="mh-tabs">
        {['Contenidos', 'Sobre'].map(tab => (
          <button
            key={tab}
            className={`mh-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Content */}
      <div className="mh-body">
        {activeTab === 'Contenidos' && (
          <div className="mh-grid">
            {modulos.length === 0 ? (
              <p className="mh-empty">Cargando módulos...</p>
            ) : (
              modulos.map((module, index) => {
                const status = moduleStatus[index];
                const unlocked = status?.unlocked;
                const completed = status?.relationExists;
                return (
                  <div
                    key={module.id}
                    className={`mh-card ${!unlocked ? 'mh-card--locked' : ''} ${completed ? 'mh-card--done' : ''}`}
                    onClick={() => unlocked && navigate(`/Modulos/${module.modulo_name}`)}
                  >
                    {/* Thumbnail */}
                    <div className="mh-card-thumb">
                      <img src="/Images/miniatura_video.png" alt="Módulo" />
                      <div className="mh-card-thumb-overlay">
                        {!unlocked
                          ? <FaLock className="mh-thumb-icon mh-thumb-icon--lock" />
                          : completed
                          ? <FaCheckCircle className="mh-thumb-icon mh-thumb-icon--done" />
                          : <FaPlayCircle className="mh-thumb-icon mh-thumb-icon--play" />
                        }
                      </div>
                      <div className="mh-card-num">Módulo {module.modulo_name}</div>
                      {completed && <div className="mh-card-badge">Completado</div>}
                    </div>

                    {/* Info */}
                    <div className="mh-card-body">
                      <h3 className="mh-card-title">{module.modulo_description}</h3>
                      <p className="mh-card-desc">{module.modulo_large_description}</p>
                      <div className="mh-card-footer">
                        {!unlocked ? (
                          <span className="mh-card-status mh-card-status--locked">
                            <FaLock /> Bloqueado
                          </span>
                        ) : completed ? (
                          <span className="mh-card-status mh-card-status--done">
                            <FaCheckCircle /> Completado
                          </span>
                        ) : (
                          <span className="mh-card-status mh-card-status--open">
                            <FaPlayCircle /> Disponible
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}

        {activeTab === 'Sobre' && (
          <div className="mh-about">
            <div className="mh-about-course">
              <h2>Sobre el Curso</h2>
              <p>
                Bienvenidos a nuestra formación en ventas, diseñada para equipar a los
                profesionales emergentes y experimentados con las habilidades, técnicas y
                estrategias esenciales para triunfar en el dinámico mundo de las ventas.
                Exploraremos los principios fundamentales, desde el proceso de ventas hasta
                la comunicación efectiva y la construcción de relaciones duraderas.
              </p>
            </div>
            <div className="mh-about-instructor">
              <div className="mh-instructor-header">
                <img src="/Images/david-foto.jpg" alt="David Giraldo" />
                <div>
                  <span className="mh-instructor-name">David Giraldo</span>
                  <span className="mh-instructor-role">CEO de CloserAcademy</span>
                </div>
              </div>
              <p>
                En el mundo actual, la habilidad de vender es esencial para el éxito
                laboral y financiero. Te ofrezco la oportunidad de aprender estas
                habilidades y trabajar desde casa, con horarios flexibles que se adapten
                a tu vida. Aprenderás a comunicarte de manera persuasiva, a superar
                objeciones y a construir relaciones duraderas con los clientes.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ModuloHome;
